import styles from "./MyProfile.module.css";
import useAuthStore from "../../store/authStore";

const MyProfile = () => {
  const { user, userMeta } = useAuthStore();
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>My Profile</h2>

      <div className={styles.grid}>
        <ProfileRow label="Username" value={user.username} />
        <ProfileRow label="Email" value={user.email} />
        <ProfileRow label="First Name" value={user.first_name} />
        <ProfileRow label="Last Name" value={user.last_name} />
        {/* <ProfileRow label="Roles" value={user?.roles?.join(", ")} /> */}
        {/* <ProfileRow label="Device Token" value={userMeta.device_token} /> */}
        <ProfileRow
          label="Membership Active"
          value={userMeta.is_membership_active ? "Yes" : "No"}
        />
        {/* <ProfileRow
          label="Membership IDs"
          value={
            Array.isArray(userMeta?.membership_ids) &&
            userMeta.membership_ids.length > 0
              ? userMeta.membership_ids.join(", ")
              : "—"
          }
        /> */}
        <ProfileRow
          label="Created At"
          value={new Date(userMeta.created_at).toLocaleString()}
        />
        <ProfileRow
          label="Updated At"
          value={new Date(userMeta.updated_at).toLocaleString()}
        />
        {/* <ProfileRow label="Session ID" value={userMeta.session_id} /> */}
        <ProfileRow label="User Role" value={user?.roles[0]} />
      </div>
    </div>
  );
};

const ProfileRow = ({ label, value }) => (
  <div className={styles.row}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

export default MyProfile;
